import React, { Suspense, useEffect } from "react";
const Agent = React.lazy(() => import("./Agent"));

// Cool loading component with animation
const CoolLoader = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '20px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
    border: '1px solid rgba(255,255,255,0.2)',
    backdropFilter: 'blur(10px)',
    animation: 'fadeIn 0.5s ease-in-out'
  }}>
    <div style={{
      width: '50px',
      height: '50px',
      border: '4px solid rgba(255,255,255,0.3)',
      borderTop: '4px solid #fff',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
      marginBottom: '1rem'
    }}></div>
    <div style={{
      color: 'white',
      fontSize: '1.2rem',
      fontWeight: '600',
      textShadow: '0 2px 4px rgba(0,0,0,0.3)',
      animation: 'pulse 2s ease-in-out infinite'
    }}>
      Loading Components...
    </div>
  </div>
);

// CSS animations
const styles = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.7; }
  }
`;

const PromptRouter = ({ intent, onBackgroundUpdate, onApiResult, onLocalStateChange, hasComponents }) => {
  // Inject styles
  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);
    return () => document.head.removeChild(styleSheet);
  }, []);

  return (
    <Suspense fallback={<CoolLoader />}>
      <Agent 
        onBackgroundUpdate={onBackgroundUpdate} 
        onApiResult={onApiResult}
        onLocalStateChange={onLocalStateChange}
        hasComponents={hasComponents}
      />
    </Suspense>
  );
};

export default PromptRouter;